import React from 'react'
// import styled from 'styled-components'

import { FormattedMessage } from '@dragonraider5/react-intl'
import CallToAction from '../../../components/CallToAction/CallToAction'
import Button from '../../../components/Button'
import messages from './messages'

// const AppCallToActionText = styled.p`
//   text-align: inherit;
// `

function AppCallToAction() {
  return (
    <CallToAction
      title={(
        <FormattedMessage {...messages.callToActionTitle} />
      )}
    >
      <Button
        as='a'
        href='mailto:solicitudfinanciacion.digital@triodos.es?subject=Solicitud Digital de Financiación'
        target='_blank'
      >
        <FormattedMessage {...messages.callToActionButton} />
      </Button>
    </CallToAction>
  )
}

export default AppCallToAction
